import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

class ThemeName extends React.Component {
    static propTypes = {
        theme: PropTypes.object
    }
    state = {
        title: null,
        onlineresource: null
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.title !== this.props.theme.attribution.Title) {
          this.setState({title: this.props.theme.attribution.Title});
        }
        if (prevState.onlineresource !== this.props.theme.attribution.OnlineResource) {
            this.setState({onlineresource: this.props.theme.attribution.OnlineResource});
        }
      }
    render() {
        return (
            <div className="themename"><a href={this.state.onlineresource} target="_blank">{this.state.title}</a></div>
        );
    }
}

const selector = (state) => ({
    theme: state.theme.current
});

export default connect(selector)(ThemeName);